import { getPublicEnvVars } from '@b-stock/fe-core/bstock-next/helpers'
import { usePusher } from '@b-stock/fe-core/bstock-react'

/**
 * WARNING: Will only work in Pages router pages.
 */
const usePusherLegacy = () => {
  const { PUBLIC_PUSHER_APP_KEY, PUBLIC_PUSHER_APP_CLUSTER } =
    getPublicEnvVars()
  return usePusher(PUBLIC_PUSHER_APP_KEY, PUBLIC_PUSHER_APP_CLUSTER)
}

export default usePusherLegacy
